import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const SettingsApi = createApi({
    reducerPath: "settings",
    tagTypes: ['About'],    
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getAbout: builder.query({
            query: () => ({
                url: `api/admin/about`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['About']
        }),

        updateAbout: builder.mutation({
            query: (text) => {
                return {
                    url: `api/admin/about`,
                    method: "PUT",
                    body: { about: text },
                }
            },
            invalidatesTags: ['About']
        }),

        getPrivacy: builder.query({
            query: () => ({
                url: `api/admin/privacy`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['Privacy']
        }),

        updatePrivacy: builder.mutation({
            query: (text) => {
                return {
                    url: `api/admin/privacy`,
                    method: "PUT",
                    body: { privacy: text },
                }
            },
            invalidatesTags: ['Privacy']
        }),

        getTerms: builder.query({
            query: () => ({
                url: `api/admin/tac`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['Terms']
        }),

        updateTerms: builder.mutation({
            query: (text) => {
                return {
                    url: `api/admin/tac`,
                    method: "PUT",
                    body: { tac: text },
                }
            },
            invalidatesTags: ['Terms']
        }),
        getAboutUsPublic:builder.query({
            query: () => ({
                url: `api/admin/about/public`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['About']
        }),
        getTermsOfServicePublic:builder.query({
            query: () => ({
                url: `api/admin/tac/public`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['Terms']
        }),
        getPrivacyPublic:builder.query({
            query: () => ({
                url: `api/admin/privacy/public`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
            providesTags: ['Privacy']
        }),
    }),
});

export const {
    useGetAboutQuery,
    useUpdateAboutMutation,
    useGetPrivacyQuery,
    useUpdatePrivacyMutation,
    useGetTermsQuery,
    useUpdateTermsMutation,
    useGetAboutUsPublicQuery,
    useGetTermsOfServicePublicQuery,
    useGetPrivacyPublicQuery,
} = SettingsApi;